export const views = { overview: 'Overview', assets: 'Assets' };

const helpers = { views };
export default helpers;
